export default "__VITE_ASSET__4905b767__"